import React from 'react';
import { Settings, Moon, Sun } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Switch } from '../ui/switch';

/**
 * DisplayPreferencesCard - Préférences d'affichage (mode sombre/clair)
 */
const DisplayPreferencesCard = ({ isDark, toggleTheme }) => {
  return (
    <Card className="relative bg-slate-950/40 backdrop-blur-xl border-slate-800/60">
      <CardHeader>
        <CardTitle className="text-xl md:text-2xl font-orbitron uppercase tracking-wider text-cyan-400 flex items-center">
          <Settings className="w-5 h-5 md:w-6 md:h-6 mr-2 md:mr-3" />
          Préférences d&apos;affichage
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between p-4 bg-slate-900/50 rounded-lg border border-slate-800">
          <div className="flex items-center gap-3">
            {isDark ? (
              <Moon className="w-5 h-5 text-slate-400" />
            ) : (
              <Sun className="w-5 h-5 text-amber-400" />
            )}
            <div>
              <p className="text-lg text-slate-200 font-medium">Mode d&apos;affichage</p>
              <p className="text-sm text-slate-500">
                {isDark ? 'Mode sombre activé' : 'Mode clair activé'}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm text-slate-400">Sombre</span>
            <Switch
              checked={!isDark}
              onCheckedChange={toggleTheme}
              data-testid="theme-toggle"
            />
            <span className="text-sm text-slate-400">Clair</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default DisplayPreferencesCard;
